"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SixsenseColor = void 0;
var Teal;
(function (Teal) {
    Teal["DEFAULT"] = "#11A79F";
    Teal["DARK_1"] = "#00898B";
    Teal["DARK_2"] = "#007375";
    Teal["DARK_3"] = "#005E61";
    Teal["DARK_4"] = "#00484C";
    Teal["DARK_5"] = "#003B3E";
    Teal["LIGHT_1"] = "#1ABBB8";
    Teal["LIGHT_2"] = "#4DCAC8";
    Teal["LIGHT_3"] = "#80D9D8";
    Teal["LIGHT_4"] = "#B4E7E7";
    Teal["LIGHT_5"] = "#E6F7F7";
    /**
     * @deprecated
     */
    Teal["LIGHT_6"] = "#E6F7F7";
})(Teal || (Teal = {}));
var Red;
(function (Red) {
    Red["DEFAULT"] = "#E12C2C";
    Red["DARK_1"] = "#CB1C23";
    Red["DARK_2"] = "#AA1723";
    Red["DARK_3"] = "#931423";
    Red["DARK_4"] = "#7A101F";
    Red["DARK_5"] = "#620D1C";
    Red["LIGHT_1"] = "#E85A5A";
    Red["LIGHT_2"] = "#EE8686";
    Red["LIGHT_3"] = "#F4B3B3";
    Red["LIGHT_4"] = "#F9D2D2";
    Red["LIGHT_5"] = "#FDEDED";
    /**
     * @deprecated
     */
    Red["LIGHT_6"] = "#FDEDED";
})(Red || (Red = {}));
var Pink;
(function (Pink) {
    Pink["DEFAULT"] = "#C52E99";
    Pink["DARK_1"] = "#A52A8D";
    Pink["DARK_2"] = "#8E257B";
    Pink["DARK_3"] = "#78206A";
    Pink["DARK_4"] = "#611A59";
    Pink["DARK_5"] = "#4B1548";
    Pink["LIGHT_1"] = "#D85AB3";
    Pink["LIGHT_2"] = "#E283C6";
    Pink["LIGHT_3"] = "#ECACD9";
    Pink["LIGHT_4"] = "#F6D5EC";
    Pink["LIGHT_5"] = "#FBEEF7";
    /**
     * @deprecated
     */
    Pink["LIGHT_6"] = "#FBEEF7";
})(Pink || (Pink = {}));
var Blue;
(function (Blue) {
    Blue["DEFAULT"] = "#0088CC";
    Blue["DARK_1"] = "#0074BD";
    Blue["DARK_2"] = "#0064A3";
    Blue["DARK_3"] = "#005185";
    Blue["DARK_4"] = "#00426B";
    Blue["DARK_5"] = "#003252";
    Blue["LIGHT_1"] = "#0AA0FF";
    Blue["LIGHT_2"] = "#3DB4FF";
    Blue["LIGHT_3"] = "#70C8FF";
    Blue["LIGHT_4"] = "#ADDFFF";
    Blue["LIGHT_5"] = "#E0F3FF";
    /**
     * @deprecated
     */
    Blue["LIGHT_6"] = "#E0F3FF";
})(Blue || (Blue = {}));
var Purple;
(function (Purple) {
    Purple["DEFAULT"] = "#863AD0";
    Purple["DARK_1"] = "#712BB5";
    Purple["DARK_2"] = "#5D2394";
    Purple["DARK_3"] = "#491B73";
    Purple["DARK_4"] = "#341353";
    Purple["DARK_5"] = "#220C36";
    Purple["LIGHT_1"] = "#9F63DA";
    Purple["LIGHT_2"] = "#B88CE4";
    Purple["LIGHT_3"] = "#D1B5EE";
    Purple["LIGHT_4"] = "#EADEF7";
    Purple["LIGHT_5"] = "#F5EFFB";
    /**
     * @deprecated
     */
    Purple["LIGHT_6"] = "#F5EFFB";
})(Purple || (Purple = {}));
var Green;
(function (Green) {
    Green["DEFAULT"] = "#2EB62D";
    Green["DARK_1"] = "#22A042";
    Green["DARK_2"] = "#1D8B3C";
    Green["DARK_3"] = "#187637";
    Green["DARK_4"] = "#136032";
    Green["DARK_5"] = "#0D4A2D";
    Green["LIGHT_1"] = "#48D247";
    Green["LIGHT_2"] = "#71DC70";
    Green["LIGHT_3"] = "#99E699";
    Green["LIGHT_4"] = "#C2F0C2";
    Green["LIGHT_5"] = "#EBFAEB";
    /**
     * @deprecated
     */
    Green["LIGHT_6"] = "#EBFAEB";
})(Green || (Green = {}));
var Violet;
(function (Violet) {
    Violet["DEFAULT"] = "#5739C3";
    Violet["DARK_1"] = "#4D2EA1";
    Violet["DARK_2"] = "#402682";
    Violet["DARK_3"] = "#321D65";
    Violet["DARK_4"] = "#251546";
    Violet["DARK_5"] = "#190D2B";
    Violet["LIGHT_1"] = "#765DD0";
    Violet["LIGHT_2"] = "#9784DB";
    Violet["LIGHT_3"] = "#B9ACE7";
    Violet["LIGHT_4"] = "#DAD3F2";
    Violet["LIGHT_5"] = "#F2EFFA";
    /**
     * @deprecated
     */
    Violet["LIGHT_6"] = "#F2EFFA";
})(Violet || (Violet = {}));
var Yellow;
(function (Yellow) {
    Yellow["DEFAULT"] = "#EBA300";
    Yellow["DARK_1"] = "#D08802";
    Yellow["DARK_2"] = "#B67402";
    Yellow["DARK_3"] = "#9B6202";
    Yellow["DARK_4"] = "#7F4F02";
    Yellow["DARK_5"] = "#643C02";
    Yellow["LIGHT_1"] = "#FFBA1F";
    Yellow["LIGHT_2"] = "#FFCA52";
    Yellow["LIGHT_3"] = "#FFD985";
    Yellow["LIGHT_4"] = "#FFE9B8";
    Yellow["LIGHT_5"] = "#FFF6E0";
    /**
     * @deprecated
     */
    Yellow["LIGHT_6"] = "#FFF6E0";
})(Yellow || (Yellow = {}));
var Gray;
(function (Gray) {
    Gray["DEFAULT"] = "#7A878F";
    Gray["DARK_1"] = "#5B6C75";
    Gray["DARK_2"] = "#415660";
    Gray["DARK_3"] = "#2C4350";
    Gray["DARK_4"] = "#1B3443";
    Gray["DARK_5"] = "#001F32";
    Gray["LIGHT_1"] = "#9EA8AD";
    Gray["LIGHT_2"] = "#BAC1C4";
    Gray["LIGHT_3"] = "#D1D4D7";
    Gray["LIGHT_4"] = "#E4E6E7";
    Gray["LIGHT_5"] = "#F5F5F6";
    /**
     * @deprecated
     */
    Gray["LIGHT_6"] = "#F5F5F6";
})(Gray || (Gray = {}));
var White;
(function (White) {
    White["DEFAULT"] = "#FFFFFF";
})(White || (White = {}));
var Black;
(function (Black) {
    Black["DEFAULT"] = "#000000";
})(Black || (Black = {}));
exports.SixsenseColor = {
    Teal: Teal,
    Red: Red,
    Pink: Pink,
    Blue: Blue,
    Purple: Purple,
    Gray: Gray,
    Green: Green,
    Violet: Violet,
    Yellow: Yellow,
    White: White,
    Black: Black,
};
